import styled, { css, keyframes } from 'styled-components'
import type { StyledBarProps } from './BulkActionBar.types'

const slideUp = keyframes`
  from { transform: translateY(8px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`

const slideDown = keyframes`
  from { transform: translateY(-8px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`

const positionStyles = {
  top: css`
    top: 0;
    animation: ${slideDown} ${({ theme }) => theme.transitions.medium};
  `,
  bottom: css`
    bottom: 0;
    animation: ${slideUp} ${({ theme }) => theme.transitions.medium};
  `,
}

export const Bar = styled.div<StyledBarProps>`
  position: sticky;
  ${({ $position }) => positionStyles[$position]};
  z-index: ${({ theme }) => theme.zIndex.sticky};
  display: ${({ $visible }) => ($visible ? 'flex' : 'none')};
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  padding: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.default};
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.lg};
  width: 100%;
`

export const Summary = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.primary};
  font-variant-numeric: tabular-nums;
`

export const ClearButton = styled.button`
  background: transparent;
  border: none;
  padding: ${({ theme }) => theme.spacing.xsmall}
    ${({ theme }) => theme.spacing.small};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  text-decoration: underline;
  border-radius: ${({ theme }) => theme.borderRadius.small};

  &:hover {
    color: ${({ theme }) => theme.colors.primaryHover};
    background: ${({ theme }) => theme.colors.background.secondary};
    text-decoration: none;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.border.focus};
    outline-offset: 2px;
  }
`

export const Spacer = styled.div`
  flex: 1;
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xsmall};
  flex-wrap: wrap;
`
